import * as D from '@nll/datum/lib/Datum';
import * as DE from '@nll/datum/lib/DatumEither';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import { useEffect, useState } from 'react';
import { makeApolloError, makeDecodeError } from './lib/make-extended-decoded-query';
export var useApolloResult = function useApolloResult(_ref) {
  var data = _ref.data,
      loading = _ref.loading,
      error = _ref.error,
      output = _ref.output;

  var _useState = useState(data),
      internalData = _useState[0],
      setData = _useState[1];

  useEffect(function () {
    if (internalData == null || data != null) setData(data);
  }, [data, internalData]);
  return loading ? internalData ? pipe(output.decode(internalData), E.mapLeft(makeDecodeError), D.refresh) : DE.pending : error ? DE.failure(makeApolloError(error)) : internalData ? pipe(output.decode(internalData), E.mapLeft(makeDecodeError), D.replete) : D.initial;
};